import React from 'react';
import {
  AMM_ASTROLOGY_BLUEPRINT_COURSE,
  AMM_PRACTICE_LAB,
  BIG_THREE_CHECKER_PATH,
} from '../../constants/chartBrandLinks';

export const CHART_CTA_LINKS = [
  {
    title: 'Explore Your Big Three',
    description: 'Start with the essentials and compare your Sun, Moon, and Rising signs.',
    href: BIG_THREE_CHECKER_PATH,
  },
  {
    title: 'Learn to Read the Full Chart',
    description: 'Continue with the Astrology Blueprint course for full interpretation practice.',
    href: AMM_ASTROLOGY_BLUEPRINT_COURSE,
  },
  {
    title: 'Practice with Real Chart Reading Reps',
    description: 'Develop confidence through guided chart-reading exercises.',
    href: AMM_PRACTICE_LAB,
  },
];

const CTASection = () => (
  <footer className="card chart-page-cta-footer" role="contentinfo" aria-label="Continue learning">
    <h2>Continue in the Astral Moon Magic ecosystem</h2>
    <div className="chart-summary-grid">
      {CHART_CTA_LINKS.map((link) => {
        const isExternal = /^https?:\/\//i.test(link.href);
        return (
          <article key={link.title}>
            <h4>{link.title}</h4>
            <p>{link.description}</p>
            <a
              href={link.href}
              className="chart-inline-link"
              {...(isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
            >
              Open
            </a>
          </article>
        );
      })}
    </div>
  </footer>
);

export default CTASection;
